import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import SafeLifeLogo from "./SafeLifeLogo";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { insuranceTypes } from "../data/insurances";

const navLinks = [
  { to: "/", label: "Início" },
  { to: "/sobre", label: "Sobre" },
  { to: "/contato", label: "Contato" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 w-full backdrop-blur-xl bg-white/85 border-b border-navy-100/50"
      data-testid="site-header"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
            <SafeLifeLogo className="h-14" />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `text-sm font-semibold transition-colors hover:text-lego ${
                    isActive ? "text-lego" : "text-navy"
                  }`
                }
                data-testid={`nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <DropdownMenu>
              <DropdownMenuTrigger
                className="text-sm font-semibold text-navy hover:text-lego outline-none"
                data-testid="nav-seguros-trigger"
              >
                Seguros <i className="fa-solid fa-chevron-down text-xs ml-1" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-64">
                {insuranceTypes.map((i) => (
                  <DropdownMenuItem asChild key={i.slug}>
                    <Link to={`/seguros/${i.slug}`} data-testid={`nav-seguro-${i.slug}`}>
                      <i className={`fa-solid ${i.icon} w-5 text-lego`} /> {i.name}
                    </Link>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </nav>

          <div className="flex items-center gap-3">
            <Button
              asChild
              className="hidden sm:inline-flex bg-brand hover:bg-brand-600 active:bg-brand-700 text-white rounded-full font-semibold px-6 h-11 shadow-soft hover:-translate-y-0.5 transition-all"
              data-testid="header-cta-cotar"
            >
              <Link to="/cotacao">
                <i className="fa-solid fa-shield-heart mr-2" />
                Cotar Grátis
              </Link>
            </Button>
            <button
              aria-label="Menu"
              onClick={() => setMobileOpen(!mobileOpen)}
              className="lg:hidden p-2 text-navy"
              data-testid="mobile-menu-btn"
            >
              {mobileOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>

        {/* Mobile drawer */}
        {mobileOpen && (
          <div className="lg:hidden pb-6 pt-2 animate-fade-in-up" data-testid="mobile-menu">
            <nav className="flex flex-col gap-4 border-t border-navy-100 pt-4">
              {navLinks.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  onClick={() => setMobileOpen(false)}
                  className="text-navy font-semibold py-2"
                >
                  {l.label}
                </Link>
              ))}
              <div className="pt-2 border-t border-navy-100">
                <p className="text-xs uppercase tracking-wider text-muted-foreground mb-2">Seguros</p>
                <div className="grid grid-cols-2 gap-2">
                  {insuranceTypes.map((i) => (
                    <Link
                      key={i.slug}
                      to={`/seguros/${i.slug}`}
                      onClick={() => setMobileOpen(false)}
                      className="text-sm text-navy/80 py-1.5"
                    >
                      <i className={`fa-solid ${i.icon} text-lego mr-2`} /> {i.short}
                    </Link>
                  ))}
                </div>
              </div>
              <Button
                asChild
                className="bg-brand hover:bg-brand-600 active:bg-brand-700 text-white rounded-full font-semibold h-12 mt-2"
              >
                <Link to="/cotacao" onClick={() => setMobileOpen(false)}>
                  Cotar Grátis
                </Link>
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
